import { type FC, type ReactNode } from 'react'

import './index.scss'

export interface CardProps {
  children: ReactNode
  className?: string
  backdrop?: boolean
}

export const Card: FC<CardProps> = ({ children, className = '', backdrop = false }) => {
  return <div className={`card ${backdrop ? 'card--backdrop' : ''} ${className}`}>{children}</div>
}
